import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const TimeSeriesChart = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-foreground mb-1">Time-Series Analysis</h3>
          <p className="text-sm text-muted-foreground">Consultation trends over time</p>
        </div>
        <div className="w-10 h-10 bg-[#E6F0F5] rounded-lg flex items-center justify-center">
          <Icon name="TrendingUp" size={20} className="text-[#002B45]" />
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip 
            content={({ active, payload }) => {
              if (active && payload && payload?.length) {
                return (
                  <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-200">
                    <p className="font-semibold text-foreground mb-2">{payload?.[0]?.payload?.month}</p>
                    {payload?.map((entry, index) => (
                      <p key={index} className="text-sm" style={{ color: entry?.color }}>
                        {entry?.name}: {entry?.value}
                      </p>
                    ))}
                  </div>
                );
              }
              return null;
            }}
          />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="consultations" 
            stroke="#3B82F6" 
            strokeWidth={2}
            name="Total Consultations"
            dot={{ fill: '#3B82F6', r: 4 }}
          />
          <Line 
            type="monotone" 
            dataKey="completed" 
            stroke="#10B981" 
            strokeWidth={2}
            name="Completed"
            dot={{ fill: '#10B981', r: 4 }}
          />
          <Line 
            type="monotone" 
            dataKey="cancelled" 
            stroke="#EF4444" 
            strokeWidth={2}
            name="Cancelled"
            dot={{ fill: '#EF4444', r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TimeSeriesChart;